import React, {useRef, forwardRef} from "react";
import {Editor} from "@tinymce/tinymce-react";

const DEFAULT_TOOLBARS = 'undo redo | forecolor bold italic underline superscript subscript removeformat | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent',
    DEFAULT_PLUGINS = 'lists textcolor';

const EditorTinyMCE = forwardRef((props, ref) => {
    const {initialValue = '', width = 600, height = 300, menubar = false, toolbars = DEFAULT_TOOLBARS, plugins = DEFAULT_PLUGINS,
            showSource = false, setContent, setLoading, handleOnClick, handleOnFocus, isFocused = false, handleOnBlur} = props,
        tinyMCERef = useRef(null);

    const handleEditorChange = (editorContent, editor) => {
        setContent(editorContent);
    };

    return (
        <div className={'ch-tiny-mce-editor-wrapper' + (isFocused ? ' focused' : '')}>
            <Editor
                onInit={(evt, editor) => {
                    tinyMCERef.current = editor;
                    setLoading(false);
                }}
                initialValue={initialValue}
                init={{
                    ...(width && { width: width + 'px' }),
                    height: height + 'px',
                    menubar: menubar,
                    plugins: plugins + (showSource ? ' code' : ''),
                    toolbar: toolbars + (showSource ? ' code' : ''),
                }}
                onEditorChange={handleEditorChange}
                onClick={handleOnClick}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
            />
        </div>
    )
});

export default EditorTinyMCE;